import React, { useState, useEffect } from "react";
import { Picker, View, StyleSheet } from "react-native";

import Dialog from "./dialog";

export default function AutoTrackPickerDialog({
  value,
  isOpen = false,
  onConfirm = () => {},
  onClose = () => {},
}) {
  const [interval, setInterval] = useState();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(isOpen);
    if (value) setInterval(value);
  }, [isOpen]);

  const updateTime = (newInterval) => {
    setInterval(newInterval);
  };

  const confirmPickerValue = () => {
    if (onConfirm) onConfirm(interval);
    onClose();
  };

  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container onClose={onClose} showCloseButton>
          <View style={styles.container}>
            <View style={styles.intervals}>
              <View style={styles.row}>
                <Picker
                  style={styles.picker}
                  selectedValue={interval}
                  onValueChange={(h) => updateTime(h)}
                >
                  <Picker.Item key={0} value="never" label="Never" />
                  <Picker.Item key={1} value="4 hours" label="4 Hours" />
                  <Picker.Item key={2} value="8 hours" label="8 Hours" />
                  <Picker.Item key={3} value="12 hours" label="12 Hours" />
                  <Picker.Item key={4} value="20 hours" label="20 Hours" />
                  <Picker.Item key={5} value="1 day" label="1 Day" />
                  <Picker.Item key={6} value="2 days" label="2 Days" />
                  <Picker.Item key={7} value="3 days" label="3 Days" />
                  <Picker.Item key={8} value="4 days" label="4 Days" />
                  <Picker.Item key={9} value="5 days" label="5 Days" />
                  <Picker.Item key={10} value="6 days" label="6 Days" />
                  <Picker.Item key={11} value="7 days" label="7 Days" />
                </Picker>
              </View>
            </View>
          </View>

          <Dialog.Button
            style={styles.buttonText}
            onPress={confirmPickerValue}
            label="DONE"
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  intervals: {
    flexDirection: "row",
    justifyContent: "center",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  picker: {
    width: 100,
  },
});
